import { ensureAuthStatus } from '@jotta/auth-client/useAuthStatus'
import type { Language } from '@jotta/grpc-connect-openapi/language'

import { patchCustomer } from './patchCustomer'

/** Persist UI language on the authenticated customer, if any. */
export async function persistCustomerLanguage(
  language: Language,
): Promise<void> {
  const { authenticated, username } = await ensureAuthStatus()
  if (authenticated && username) {
    await patchCustomer({
      language: {
        language,
      },
    })
  }
}
